import { LoadingSpinner } from "@/components/ui/loading-spinner";
import { cn } from "@/lib/utils";

interface PageLoaderOverlayProps {
  message?: string;
  opacity?: "light" | "medium" | "dark";
  className?: string;
}

export default function PageLoaderOverlay({
  message = "Loading data...",
  opacity = "medium",
  className,
}: PageLoaderOverlayProps) {
  const opacityClass = {
    light: "bg-black/20 backdrop-blur-sm",
    medium: "bg-black/40 backdrop-blur-sm",
    dark: "bg-black/60 backdrop-blur-sm",
  }[opacity];

  return (
    <div className="relative min-h-dvh w-full" aria-hidden="true">
      <div
        className={cn(
          "absolute inset-0 z-50 flex items-center justify-center",
          opacityClass,
          className,
        )}
      >
        <div className="flex flex-col items-center gap-6">
          <LoadingSpinner size="xl" />
          <p className="text-lg text-foreground">{message}</p>
        </div>
      </div>
    </div>
  );
}
